import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import BodyText from "core/BodyText";
import { PaypalContentContainer, PayPalPurchaseTitle } from "./styles";

import colors from "core/colors";

const paymentText = {
    title: "Click the “PayPal” button below to purchase",
    paragraph:
        "You will be redirected to the PayPal site to complete your payment. After payment, you will be redirected back to Noun Project to complete your order."
};

let PaypalPaymentContent = ({ className }) => (
    <PaypalContentContainer
        className={className}
        tabIndex={0}
        aria-label={`${paymentText.title}. ${paymentText.paragraph}`}
    >
        <PayPalPurchaseTitle>{paymentText.title}</PayPalPurchaseTitle>
        <BodyText type="p" copyColor={colors.secondary.oolong} size="md">
            {paymentText.paragraph}
        </BodyText>
    </PaypalContentContainer>
);

PaypalPaymentContent = styled(PaypalPaymentContent)``;

PaypalPaymentContent.propTypes = {
    className: PropTypes.string
};

export default PaypalPaymentContent;
